import template from 'lodash/template';

// eslint-disable-next-line clean-regex/consistent-match-all-characters
export const DEFAULT_INTERPOLATE = /{([\S\s]+?)}/g;

export type TParams = Record<string, string | number> | undefined;

/**
 * Функция шаблонизатор
 * @param params Значения которые будут подставлены в шаблон
 */
export type TTemplate<P extends TParams> = (params?: P) => string;

/**
 * Создать шаблонизатор
 * @param templateString Строка шаблона
 * @param interpolate Регулярное выражение интерполяции (по умолчанию: `/{([\S\s]+?)}/g`)
 * @example
 * const urlTemplate = '//alfabank.ru/users/{id}/profile';
 * const url = createTemplate(urlTemplate);
 * url() // '//alfabank.ru/users/{id}/profile'
 * url({ id: '123' }); // '//alfabank.ru/users/123/profile'
 * @returns Функция шаблонизатор
 */
export const createTemplate =
    <P extends TParams>(templateString: string, interpolate = DEFAULT_INTERPOLATE): TTemplate<P> =>
    params => {
        if (!params) return templateString;

        const execute = template(templateString, {
            interpolate,
        });

        return execute(params);
    };
